export interface LinkResolverParams {
  type: string
  uid: string
  lang: string
}
/**
 * Prismic link resolver from document
 * @param doc
 * @returns url processed of the document into the website
 */
export default function linkResolver(doc: LinkResolverParams): string {
  switch (doc?.type) {
    case 'blog':
      return `/${doc?.lang}/blog`
    case 'article':
      return `/${doc?.lang}/blog/${doc?.uid}`
    case 'category':
      return `/${doc?.lang}/blog?category=${doc?.uid}`
    case 'legals_page':
      return `/${doc?.lang}/legals/${doc?.uid}`
    case 'home_page':
      return `/${doc?.lang}/`
    default:
      return `/${doc?.lang}/${doc?.uid}`
  }
}
